import Registration from '~/src/Registration';
import Countries from '~/src/Countries';

const countries = [
  { name: 'English', code: 'gb', translations: () => import('~/src/translations/gb.json') },
  { name: 'Deutschland', code: 'de', translations: () => import('~/src/translations/de.json') },
  { name: 'Österreich', code: 'at', translations: () => import('~/src/translations/at.json') },
  { name: 'Schweiz', code: 'ch', translations: () => import('~/src/translations/ch-de.json') },
  { name: 'Greece', code: 'gr', translations: () => import('~/src/translations/gr.json') },
  { name: 'Cyprus', code: 'cy', translations: () => import('~/src/translations/cy.json') },
  { name: 'Poland', code: 'pl', translations: () => import('~/src/translations/pl.json') },
  { name: 'Slovenia', code: 'si', translations: () => import('~/src/translations/si.json') },
  { name: 'Croatia', code: 'hr', translations: () => import('~/src/translations/hr.json') },
  { name: 'Bosnia and Herzegovina', code: 'ba', translations: () => import('~/src/translations/ba.json') },
  { name: 'Hungary', code: 'hu', translations: () => import('~/src/translations/hu.json') },
  { name: 'Bulgaria', code: 'bg', translations: () => import('~/src/translations/bg.json') },
  { name: 'Romania', code: 'ro', translations: () => import('~/src/translations/ro.json') },
  { name: 'Moldova', code: 'md', translations: () => import('~/src/translations/md.json') },
  { name: 'Serbia', code: 'si', translations: () => import('~/src/translations/si.json') },
  { name: 'Montenegro', code: 'me', translations: () => import('~/src/translations/me.json') },
  { name: 'Turkey', code: 'tr', translations: () => import('~/src/translations/tr.json') },
  { name: 'Cyprus - Turkish', code: 'cyt', translations: () => import('~/src/translations/cy-tr.json') },
  { name: 'Ukraine', code: 'ua', translations: () => import('~/src/translations/ua.json') },
  { name: 'Russia', code: 'ru', translations: () => import('~/src/translations/ru.json') },
  { name: 'Ukraine - Russian', code: 'uar', translations: () => import('~/src/translations/ua-ru.json') },
  { name: 'Czech Republic', code: 'cz', translations: () => import('~/src/translations/cz.json') },
  { name: 'Slovakia', code: 'sk', translations: () => import('~/src/translations/sk.json') },
  { name: 'Lithuania', code: 'lt', translations: () => import('~/src/translations/lt.json') }
];

export default [
  {
    path: '/:language',
    component: Registration,
    props: route => {
      return {
        translations: countries.find(country => country.code === route.params.language).translations()
      };
    }
  },
  {
    path: '/',
    component: Countries,
    props: {
      countries
    }
  }
];
